<template>
  <section class="section container">
    <h1 class="title is-4 is-pulled-right mb-0">
      {{ $t("tailoring outsourcing module configuration") }}
    </h1>

    <div class="container mt'5">
      <h1 class="title is-5">{{ $t("inventory integration") }}</h1>
      <div class="columns">
        <div class="column is-3">
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_integrate_inventory"
              v-model="meta.integrate_inventory"
            />
            <label for="chk_integrate_inventory">{{
              $t("integrate inventory")
            }}</label>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('movement type on product finished')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/inventory/movement_type/catalog"
              name_field="name"
              value_field="movement_type_id"
              @selected="set_finish_movement_type"
              ref="finish_movement_type_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('movement type on product unfinished')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/inventory/movement_type/catalog"
              name_field="name"
              value_field="movement_type_id"
              @selected="set_unfinish_movement_type"
              ref="unfinish_movement_type_dropdown"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="field mt-5">
      <div class="control">
        <button class="button is-rounded is-primary" @click="save">
          <span class="icon"><i class="fa fa-save"></i></span>
          <span>{{ $t("save") }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
} from "@/utils";
import { isEmpty } from "lodash";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import "bulma-extensions/bulma-divider/dist/css/bulma-divider.min.css";

export default {
  name: "SaleSettings",
  components: { GenericDropdown },
  data() {
    return {
      meta: {
        integrate_drive: false,
        drive_id: "",
      },
    };
  },
  methods: {
    save() {
      let v = this;
      v.$root.loader(true);
      save_configuration(this, v.meta)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    drive_changed(drive) {
      let v = this;
      v.meta.drive_id = drive.drive_id;
    },
    set_finish_movement_type(movement_type) {
      let v = this;
      v.meta.finish_movement_type_id = movement_type.movement_type_id;
    },
    set_unfinish_movement_type(movement_type) {
      let v = this;
      v.meta.unfinish_movement_type_id = movement_type.movement_type_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        // console.log("conf", conf);
        if (!isEmpty(conf)) {
          v.meta = conf;

          if (conf.finish_movement_type_id)
            v.$refs.finish_movement_type_dropdown.set_value(
              conf.finish_movement_type_id
            );

          if (conf.unfinish_movement_type_id)
            v.$refs.unfinish_movement_type_dropdown.set_value(
              conf.unfinish_movement_type_id
            );

          //   v.meta = conf;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
